import React from 'react';
import { usePush } from '../contexts/PushContext';
import { useI18n } from '../contexts/I18nContext';
import { Bell, X } from '@phosphor-icons/react';
import { Button } from './ui/button';

export default function PushPermissionBanner() {
  const { showBanner, subscribeToPush, dismissBanner, pushSupported } = usePush();
  const { lang } = useI18n();

  if (!showBanner || !pushSupported) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:w-96 bg-[#11100F] text-white p-4 rounded-sm shadow-2xl z-50 animate-fade-in" data-testid="push-banner">
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 bg-[#534AB7] rounded-sm flex items-center justify-center flex-shrink-0">
          <Bell size={20} weight="bold" />
        </div>
        <div className="flex-1">
          <p className="text-sm font-bold mb-1">
            {lang === 'de' ? 'Push-Benachrichtigungen' : 'Push Notifications'}
          </p>
          <p className="text-xs text-gray-400 leading-relaxed">
            {lang === 'de'
              ? 'Erhalte sofortige Updates zu Buchungen, Nachrichten und mehr.'
              : 'Get instant updates on bookings, messages and more.'}
          </p>
          <div className="flex gap-2 mt-3">
            <Button
              data-testid="enable-push-btn"
              onClick={subscribeToPush}
              className="bg-[#534AB7] hover:bg-[#3F3792] text-white rounded-sm text-xs h-8 px-4"
            >
              {lang === 'de' ? 'Aktivieren' : 'Enable'}
            </Button>
            <Button
              data-testid="dismiss-push-btn"
              onClick={dismissBanner}
              variant="ghost"
              className="text-gray-400 hover:text-white rounded-sm text-xs h-8 px-3"
            >
              {lang === 'de' ? 'Später' : 'Later'}
            </Button>
          </div>
        </div>
        <button onClick={dismissBanner} className="text-gray-500 hover:text-white p-0.5">
          <X size={16} />
        </button>
      </div>
    </div>
  );
}
